// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.showRightPanel {\n    overflow: hidden;\n    position: relative;\n    width: calc(100% - 15px);\n}\n", ""]);
// Exports
module.exports = exports;
